export enum FlagKind {
  BOOLEAN = 'boolean',
  MULTIVARIATE = 'multivariate',
}

export const flagKinds = FlagKind;

export enum VariationType {
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  STRING = 'string',
  JSON = 'json',
}
export const variationTypes = VariationType;
